import { Draft } from 'immer'
import { BlockResponse } from '../types'

type DeleteBlockConnectorParams = {
  blockConnectorId: string
}

export const deleteBlockConnector = (params: DeleteBlockConnectorParams) => {
  return (draftDocument: Draft<BlockResponse>) => {
    if (!draftDocument.data) return draftDocument

    draftDocument.data.details.connectors =
      draftDocument.data.details.connectors.filter(
        (connector) => connector.id !== params.blockConnectorId
      )

    return draftDocument
  }
}
